import {
  onCLS,
  onFCP,
  onINP,
  onLCP,
  onTTFB,
} from "web-vitals";

export const GARFIELD_OBJ_NAME = "gf";
export const GARFIELD_NAMESPACE = "SB_WEB";
export const GARFIELD_EVENT_NAME =
  "HELP_SECTION_WEB_VITALS";

export const WEB_VITALS_EVENT_TAGS = {
  NAME: "t0",
  PATH_NAME: "t1",
  VALUE: "t2",
  RATING: "t3",
  NAVIGATION_TYPE: "t4",
  DELTA: "t5",
};

const sendToGarfield = (
  { name, delta, value, rating, navigationType },
  eventname,
  pathname
) => {
  window[GARFIELD_OBJ_NAME]?.("send", {
    eventType: "custom",
    eventName: eventname,
    value: eventname,
    data: {
      tags: {
        [WEB_VITALS_EVENT_TAGS.NAME]: name,
        [WEB_VITALS_EVENT_TAGS.PATH_NAME]: pathname,
        [WEB_VITALS_EVENT_TAGS.VALUE]: value,
        [WEB_VITALS_EVENT_TAGS.RATING]: rating,
        [WEB_VITALS_EVENT_TAGS.NAVIGATION_TYPE]: navigationType,
        [WEB_VITALS_EVENT_TAGS.DELTA]: delta,
      },
    },
  });
};

export const trackWebVitals = (eventname, pathname) => {
  onCLS(metrics =>
    sendToGarfield(metrics, eventname, pathname)
  );
  onINP(metrics =>
    sendToGarfield(metrics, eventname, pathname)
  );
  onLCP(metrics =>
    sendToGarfield(metrics, eventname, pathname)
  );
  onFCP(metrics =>
    sendToGarfield(metrics, eventname, pathname)
  );
  onTTFB(metrics =>
    sendToGarfield(metrics, eventname, pathname)
  );
};

export const addGarfield = () => {
  (function (
    window,
    document,
    tag,
    scriptSrc,
    objectName,
    a,
    m
  ) {
    if (!scriptSrc) return;
    window["GaNamespaceId"] = GARFIELD_NAMESPACE;
    window["GarfieldObjName"] = objectName;
    (window[objectName] =
      window[objectName] ||
      function () {
        (window[objectName].q =
          window[objectName].q || []).push(arguments);
      }),
      (window[objectName].l = 1 * new Date());
    (a = document.createElement(tag)),
      (m = document.getElementsByTagName(tag)[0]);
    a.async = 1;
    a.src = scriptSrc;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    process.env.GATSBY_GARFIELD_SCRIPT_SRC,
    GARFIELD_OBJ_NAME
  );
};
